import { styled } from '@/style';

const LabelText = styled.divBox`
  font-size: md;
  font-weight: 600;
`;

export default LabelText;
